export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  root: "main-nav",
  logo: "nav-logo",
  ctaButton: "nav-cta-button",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  root: "hero-section",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  vsl: "hero-vsl-placeholder",
};

export const FORM = {
  root: "diagnosis-form",
  nome: "form-nome",
  empresa: "form-empresa",
  whatsapp: "form-whatsapp",
  email: "form-email",
  processo: "form-processo",
  temApi: "form-tem-api",
  descricao: "form-descricao",
  submit: "form-submit",
  success: "form-success",
};
